/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorFalse extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorFalse");
    }

    getFixupPrototypeFunction() { return QueryOperatorFalse.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorFalse>): QueryOperatorFalse {
        let obj = Object.assign(new QueryOperatorFalse(), model);
        QueryOperatorFalse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorFalse>): QueryOperatorFalse {
        if (!model) return null;
        return QueryOperatorFalse.newInstance(<QueryOperatorFalse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorFalse) {
        if (!obj) return;

        models.QueryOperatorFalse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorFalse): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorFalse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
